<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            

            <div class="row">
              <div class="d-flex align-items-center">

                <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                  
                  <div class="search-input">
                      <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                              alt="img" /></a>
                      <div id="DataTables_Table_0_filter" class="dataTables_filter">
                          <label>
                              <input type="search" class="form-control form-control-sm"
                                  placeholder="Search..." aria-controls="DataTables_Table_0"
                                  v-model="query" />
                          </label>
                      </div>
                  </div>
  
  
                    
                </div>
                <div class="wordset">
                    <ul>
                        <!-- <li class="" >
                            <router-link class=" d-flex flex-column justify-content-between  align-items-center " to="importschedule" style="margin-top: 15px !important; margin-bottom: 0px !important;"><vue-feather
                                    type="upload" class="text-success"></vue-feather> <span class="text-black">Import</span></router-link>
                        </li> -->

                        <li>
                            <div class="form-group" style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <!-- <datepicker v-model="periode" class="picker" :editable="true"
                                        :clearable="false" @update:modelValue="index" /> -->
                                    <!-- <a class="addonset">
                                        <i class='bx bx-calendar'></i>
                                    </a> -->
                                    <DatePicker 
                                        v-model:value="periode" 
                                        type="date"
                                        range
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :clearable="true"
                                        class="picker"
                                        
                                        style="width: 268px !important;" 
                                    />

                                    <!-- @change="onDateChange" pindahin ke datepicker klo harus langsung triggered ke index methods -->
                                </div>
                            </div>
                        </li>

                        <li class="d-flex align-items-center gap-3">
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Generate"
                                @click="generateData"
                                class="d-flex flex-column justify-content-center  align-items-center mt-2 btn btn-primary p-1">
                                <i class='bx bx-refresh' style="font-size: 25px;"></i> 
                                <!-- <span
                                    class="text-black">
                                    generate
                                </span> -->
                            </a>

                           
                            <!-- <router-link data-bs-toggle="tooltip" data-bs-placement="top" title="Import"
                                class=" d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2"
                                to="importannual" style=" margin-bottom: 0px !important;">
                                <img src="../../../assets/img/import-from-excel.png" alt="img" width="25" />
                            
                            </router-link> -->
                                   

                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                @click="insert"
                                class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2"><img
                                    src="../../../assets/img/Import_fill.png" alt="img" width="25" /> 
                                    <!-- <span
                                    class="text-black">
                                    excel
                                </span> -->
                            </a>

                           

                        </li>
  
                        
                        
  
                    </ul>
                </div>

              </div>
              
              <div class="table-responsive mt-3">
                  <a-table :columns="columns" :data-source="filteredData">
                      <template #bodyCell="{ column, record }">
                          <template v-if="column.key === 'no'">
                              <div class="productimgname">
                                  {{ record.no }}
                              </div>
                          </template>
                          <!-- <template v-if="column.key === 'deskripsi'">
                              <div class="productimgname">
                                  {{ shortenDescription(record.deskripsi) }}
                              </div>
  
  
                          </template> -->

                          <template v-if="column.key === 'jumlah_hari'" >
                            <p class="text-end">

                              {{ Math.floor(record.jumlah_hari) }}
                            </p>
                              <!-- <div class="productimgname " >
                                 
                                  
                              </div> -->
  
  
                          </template>

                        <template v-if="column.key === 'leave_balance'">
                              <p class="text-end" >
                                  {{ record.leave_balance }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'remaining_balance'">
                              <p class="text-end" >
                                  {{ record.remaining_balance }}
                              </p>
  
  
                          </template>
                          
  
                          <!-- <template v-else-if="column.key === 'action'">
                              
                              <router-link class="me-3" to="editother_deduction" @click="edit(record);">
                                  <img src="@/assets/img/icons/edit.svg" alt="img" />
                              </router-link>
                              <a class="confirm-text" href="javascript:void(0);"
                                  @click="terminate(record.id, record.nama_departemen); showModal('terminate');">
                                  <img src="@/assets/img/icons/delete.svg" alt="img" />
                              </a>
                          </template> -->
                      </template>
                  </a-table>
              </div>
            </div>

          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>

<style>
.ant-picker-focused {
  border-color: #08b77e !important;
  box-shadow: 0 0 0 2px rgba(24, 255, 74, 0.2);
  border-right-width: 1px !important;
  outline: 0;
}

.ant-picker {
  border-radius: 5px !important;
}

.ant-picker:hover,
.ant-picker-focused {
  border-color: #08b77e !important;
  border-right-width: 1px !important;
}

.ant-table-cell .cell-right {
  text-align: right !important;

}

</style>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage,} from "@/assets/js/function";
import { ref, watch } from 'vue';

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'



const month = ref({
  month: new Date().getMonth(),
  year: new Date().getFullYear()
});

export default {
  // components: {
  //   Form,
  //   Field,
  // },
  components: {
        DatePicker
        
  },

  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Annual Leave Report",
      title1: "generate Annual leave report",
      config: "",
      api: "",

      // periode: new Date(),
      periode: [],

      data: [],
      columns: [
              {
                  title: "No",
                  dataIndex: "no",
                  key: "no",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.no.toLowerCase();
                          b = b.no.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Employee ID",
                  dataIndex: "employee_id",
                  key: "employee_id",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.employee_id.toLowerCase();
                          b = b.employee_id.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
              {
                  title: "Employee Name",
                  dataIndex: "nama",
                  key: "nama",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.nama.toLowerCase();
                          b = b.nama.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "Join Date",
                  dataIndex: "join_date",
                  key: "join_date",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.join_date.toLowerCase();
                          b = b.join_date.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Leave Balance",
                  dataIndex: "balance",
                  key: "balance",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.balance.toLowerCase().localeCompare(a.balance.toLowerCase());
                          b = b.balance.toLowerCase().localeCompare(b.balance.toLowerCase());
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Remaining Leave Balance",
                  dataIndex: "remaining",
                  key: "remaining",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.remaining.toLowerCase().localeCompare(a.remaining.toLowerCase());
                          b = b.remaining.toLowerCase().localeCompare(b.remaining.toLowerCase());
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              

              // {
              //     title: "Action",
              //     key: "action",
              //     sorter: false,
              // },
      ],

      //filter
      query: "",

      //data
      currentData: {
      },
      month: month,
      startDate: new Date,
      endDate: new Date,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 90000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'view')
    
    // Set default date range (1st to last day of current month)
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // zero-based
    const start = new Date(year, month, 1);
    const end = new Date(year, month + 1, 0);

    this.periode = [
      this.formatDateLocal(start),
      this.formatDateLocal(end),
    ];

  },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },
  
  computed: {
    filteredData() {
      // If no query entered, return all data
      if (this.query === '') {
        return this.data;
      }

      const lowerCaseQuery =  (this.query || '').toLowerCase();

      return this.data.filter(item => {
        return (
          (item.nama_karyawan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.employee_id2 || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_tetap || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_tidak_tetap || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_transport || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_makan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_kehadiran || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_lain || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_lain2 || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.additional || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.deduction || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.bpjs_tenaga_kerja || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.bpjs_kesehatan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.pph21 || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.total_amount || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.jumlah_hari || '').toLowerCase().includes(lowerCaseQuery)
        );
      });
    }
  },

  methods: {


    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    formatDateLocal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    async insert() {
        
        let formData = new FormData();
        appendForm(formData)

        if (this.periode && this.periode.length === 2) {
            const [startDate, endDate] = this.periode;
            formData.append("dfrom",  startDate);  // end date
            formData.append("dto", endDate);  // start date
        }
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // CloseLoading(); return;

        const api = base_url + '/v3/reports/annual_leave_excel';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        // console.log('ini data overtime:', data)

        if(data.status){
            window.open(data.data.file_report, "_blank");
            
        }else {
            AlertPopup2("error", "", data.message, true, 1500);
        }

       
        
    },

    onDateChange(value) {
        this.periode = value;
        this.index();
    },

    generateData() {
        this.index()
    },

    async index() {
        
        let formData = new FormData();
        appendForm(formData)
        // Ensure periode has both start and end dates
        if (this.periode && this.periode.length === 2) {
            const [startDate, endDate] = this.periode;
            formData.append("dfrom",  startDate);  // end date
            formData.append("dto", endDate);  // start date
        }
        
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // return;

        const api = base_url + '/v3/reports/annual_leave';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        console.log('ini data payroll:', data)
        
        if(data.status){
          const annual = data.data.data_annual_leave;
            this.data = [];

            annual.forEach((item, index) => {
                let item_prepare = { ...item, no: (index + 1), };
                this.data.push(item_prepare);
            });
            
        }else {
            AlertPopup2("error", "", data.message, true, 1500);
        }

       

    },

    


  }

};
</script>

